import { render, staticRenderFns } from "./optionItem.vue?vue&type=template&id=10872572&scoped=true"
import script from "./optionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./optionItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./optionItem.vue?vue&type=style&index=0&id=10872572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10872572",
  null
  
)

export default component.exports